import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useAppStore } from '@/stores/app'
import FullPageLoader from '@/components/Layout/FullPageLoader.vue'
import ErrorModal from '@/components/Layout/Modals/ErrorModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appStore = useAppStore()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    (_unref(appStore).isFetching)
      ? (_openBlock(), _createBlock(FullPageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(appStore).error)
      ? (_openBlock(), _createBlock(ErrorModal, {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).error = ''))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})